export default __webpack_public_path__ + "static/media/03.475054c2.jpg";